import { render, staticRenderFns } from "./EmailMessageTemplateLinkSection.vue?vue&type=template&id=e007b506&scoped=true"
import script from "./EmailMessageTemplateLinkSection.vue?vue&type=script&lang=js"
export * from "./EmailMessageTemplateLinkSection.vue?vue&type=script&lang=js"
import style0 from "./EmailMessageTemplateLinkSection.vue?vue&type=style&index=0&id=e007b506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e007b506",
  null
  
)

export default component.exports